module.exports = __webpack_public_path__ + "static/media/filter.5401e12c.svg";